<template>
    <div style="height: 100%">
        <div style="width: 100%">
            <el-row class="filter-bar filter-row" ref="filterBar">
                <el-select size="mini" v-model="formDatas.arfdFrom" clearable @change="partserch" placeholder="请选择扣减渠道"
                    style="width: 150px;">
                    <el-option label="系统" :value="1"></el-option>
                    <el-option label="易宝通" :value="2"></el-option>
                    <el-option label="河北小程序" :value="3"></el-option>
                    <!-- 4=内部商城(内部商城配套新增) -->
                    <el-option label="内部商城" :value="4"></el-option>
                </el-select>
                <el-input size="mini" v-model="formDatas.phone" clearable placeholder="请输入手机号" style="width: 130px;"
                    @keyup.enter.native="partserch"></el-input>
                <el-input size="mini" v-model="formDatas.uniqueNum" clearable placeholder="请输入唯一凭证"
                    style="width: 160px;" @keyup.enter.native="partserch"></el-input>
                <el-input size="mini" v-model="formDatas.specsSku" clearable placeholder="请输入商品编码" style="width: 130px;"
                    @keyup.enter.native="partserch"></el-input>
                <el-select size="mini" v-model="formDatas.arfdStatus" clearable @change="partserch" placeholder="请选择状态"
                    style="width: 110px;">
                    <el-option label="成功" :value="1"></el-option>
                    <el-option label="失败" :value="2"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.arfdSyncEquityfee" clearable @change="partserch"
                    placeholder="是否同步" style="width: 110px;">
                    <el-option label="否" :value="1"></el-option>
                    <el-option label="是" :value="2"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.acrStatus" clearable @change="partserch" placeholder="请选择券状态"
                    style="width: 130px;">
                    <el-option label="已撤销" :value="0"></el-option>
                    <el-option label="创建" :value="1"></el-option>
                    <el-option label="第三方导入" :value="2"></el-option>
                    <el-option label="第三方领取" :value="3"></el-option>
                    <el-option label="已核销" :value="4"></el-option>
                    <el-option label="已分账" :value="5"></el-option>
                    <el-option label="已退款" :value="6"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.arfdHandlerStatus" clearable @change="partserch"
                    placeholder="处理状态" style="width: 110px;">
                    <el-option label="不需要" :value="0"></el-option>
                    <el-option label="否" :value="1"></el-option>
                    <el-option label="是" :value="2"></el-option>
                    <el-option label="失败" :value="3"></el-option>
                </el-select>
                <el-select size="mini" v-model="formDatas.arfdStatusYd" clearable @change="partserch"
                    placeholder="权益金状态" style="width: 110px;">
                    <el-option label="正常扣减" :value="1"></el-option>
                    <el-option label="已退款" :value="2"></el-option>
                </el-select>
                <!-- 交易时间范围选择器（合并原 createTimeStart/createTimeEnd，仅日期，无时分秒） -->
                <el-date-picker size="mini" v-model="dateRange.createTime" type="daterange" value-format="yyyy-MM-dd"
                    range-separator="至" start-placeholder="交易开始日期" end-placeholder="交易结束日期" style="width: 260px;"
                    :picker-options="createTimePickerOptions" popper-class="date-range-shortcut__panel"
                    @focus="onPickerFocus('createTime')" @change="onCreateTimeRangeChange"></el-date-picker>
                <!-- 核销时间范围选择器（合并原 exchangeTimeStart/exchangeTimeEnd，仅日期，无时分秒） -->
                <el-date-picker size="mini" v-model="dateRange.exchangeTime" type="daterange" value-format="yyyy-MM-dd"
                    range-separator="至" start-placeholder="核销开始日期" end-placeholder="核销结束日期" style="width: 260px;"
                    :picker-options="exchangeTimePickerOptions" popper-class="date-range-shortcut__panel"
                    @focus="onPickerFocus('exchangeTime')" @change="onExchangeTimeRangeChange"></el-date-picker>
                <el-input size="mini" v-model="formDatas.orderNum" clearable placeholder="请输入订单号" style="width: 130px;"
                    @keyup.enter.native="partserch"></el-input>
                <div class="filter-actions">
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch">搜索</el-button>
                <el-button type="warning" size="mini" icon="el-icon-download" @click="handleExport">导出</el-button>
          </div>
        </el-row>
        </div>
        <div class="tablemain">
            <div class="tablecss" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
                element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
        </div>

        <!-- 编辑运营描述弹窗 -->
        <el-dialog title="编辑运营描述" :visible.sync="dialogVisible" width="500px">
            <el-input type="textarea" v-model="operationDes" :rows="4" placeholder="请输入运营描述"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveOperationDes">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { calcTableHeight } from "../../utils/tableHeight.js";
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjefRightsFundDeductCopyList,
    updateAjefRightsFundDeductCopyHandlerOperation
} from "../../api/api";
export default {
    name: "RightsFundDeductCopy",
    components: {},
    data() {
        return {
            totalCount: 100,
            tableLoading: false,
            tableHight: 520,
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            columns: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "arfdFrom",
                    key: "arfdFrom",
                    title: "扣减渠道",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        // 扣减渠道:1系统 2易宝通 3河北小程序 4内部商城
                        return row.arfdFrom == 1 ? '系统' : row.arfdFrom == 2 ? '易宝通' : row.arfdFrom == 4 ? '内部商城' : '河北小程序';
                    },
                },
                {
                    field: "uniqueNum",
                    key: "uniqueNum",
                    title: "唯一凭证",
                    align: "center",
                    width: 180,
                },
                {
                    field: "phone",
                    key: "phone",
                    title: "手机号",
                    align: "center",
                    width: 120,
                },
                {
                    field: "amount",
                    key: "amount",
                    title: "金额(分)",
                    align: "center",
                    width: 90,
                },
                {
                    field: "arfdStatus",
                    key: "arfdStatus",
                    title: "状态",
                    align: "center",
                    width: 80,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.arfdStatus == 1 ? <el-tag type="success">成功</el-tag> : <el-tag type="danger">失败</el-tag>;
                    },
                },
                { field: "specsSku", key: "specsSku", title: "商品编码", width: 130, align: "center" },
                { field: "arfdGoodsNum", key: "arfdGoodsNum", title: "商品数量", width: 130, align: "center" },
                { field: "specsName", key: "specsName", title: "商品名称", width: 130, align: "center" },
                { field: "createtime", key: "createtime", title: "交易时间", width: 160, align: "center" },
                // {
                //     field: "arfdSyncEquityfee",
                //     key: "arfdSyncEquityfee",
                //     title: "是否同步",
                //     align: "center",
                //     width: 80,
                //     renderBodyCell: ({ row, column, rowIndex }, h) => {
                //         if (row.arfdSyncEquityfee == 1) return <el-tag type="warning">否</el-tag>;
                //         if (row.arfdSyncEquityfee == 2) return <el-tag type="success">是</el-tag>;
                //         return '-';
                //     },
                // },
                { field: "asNameGet", key: "asNameGet", title: "商户(领取)", width: 180, align: "center" },
                { field: "asName", key: "asName", title: "商户(核销)", width: 180, align: "center" },
                { field: "orderNum", key: "orderNum", title: "订单号", width: 310, align: "center" },
                { field: "orderNumSub", key: "orderNumSub", title: "子订单号", width: 310, align: "center" },
                // { field: "acrId", key: "acrId", title: "券记录ID", width: 100, align: "center" },
                { field: "createusername", key: "createusername", title: "创建人", width: 100, align: "center" },
                {
                    field: "acrStatus",
                    key: "acrStatus",
                    title: "券状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const statusMap = {
                            0: { text: '已撤销', type: 'info' },
                            1: { text: '创建', type: '' },
                            2: { text: '第三方导入', type: 'warning' },
                            3: { text: '第三方领取', type: 'warning' },
                            4: { text: '已核销', type: 'success' },
                            5: { text: '已分账', type: 'success' },
                            6: { text: '已退款', type: 'danger' }
                        };
                        const status = statusMap[row.acrStatus];
                        return status ? <el-tag type={status.type}>{status.text}</el-tag> : '-';
                    },
                },
                { field: "acrExchangeTime", key: "acrExchangeTime", title: "核销时间", width: 160, align: "center" },
                // 商户订单分账信息(后端doGetShopOrderBill按 arfd_id->ypo_id/mrch_order_no/asor_order_no 三链路关联填充;未匹配或未分账展示为空)
                // 参与分账金额=档位基准;商铺分账金额=基准按票种折算的实得,票种非1时两者不同
                { field: "asorAmountBillYuan", key: "asorAmountBillYuan", title: "参与分账金额", width: 110, align: "center" },
                { field: "asorExchangeShopYuan", key: "asorExchangeShopYuan", title: "商铺分账金额", width: 110, align: "center" },
                // 分账时间(2026-10-13):首次分账成功时间,退款不覆盖
                { field: "asorBillTime", key: "asorBillTime", title: "分账时间", width: 160, align: "center" },
                // 供应商(2026-10-13):内部商城订单按订单号关联商城订单->供货商;其他渠道为空
                {
                    field: "amsName", key: "amsName", title: "供应商", width: 130, align: "center",
                    renderBodyCell: ({ row }) => (row.amsName != null && row.amsName !== "" ? row.amsName : "-"),
                },
                {
                    field: "arfdStatusYd",
                    key: "arfdStatusYd",
                    title: "权益金状态",
                    align: "center",
                    width: 100,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        if (row.arfdStatusYd == 1) return <el-tag type="success">正常扣减</el-tag>;
                        if (row.arfdStatusYd == 2) return <el-tag type="warning">已退款</el-tag>;
                        return '-';
                    },
                },
                {
                    field: "arfdHandlerStatus",
                    key: "arfdHandlerStatus",
                    title: "处理状态",
                    align: "center",
                    fixed: 'right',
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const statusMap = {
                            0: { text: '不需要', type: 'info' },
                            1: { text: '否', type: 'warning' },
                            2: { text: '是', type: 'success' },
                            3: { text: '失败', type: 'danger' }
                        };
                        const status = statusMap[row.arfdHandlerStatus];
                        return status ? <el-tag type={status.type}>{status.text}</el-tag> : '-';
                    },
                },
                { field: "arfdHandlerStatusDes", fixed: 'right', key: "arfdHandlerStatusDes", title: "处理状态描述", width: 150, align: "center" },
                { field: "arfdHandlerOperation", fixed: 'right', key: "arfdHandlerOperation", title: "运营描述", width: 150, align: "center" },
                {
                    field: "action",
                    key: "action",
                    title: "操作",
                    width: 80,
                    align: "center",
                    fixed: 'right',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h('el-button', {
                            props: { type: 'text', size: 'mini' },
                            style: { color: '#409EFF' },
                            on: { click: () => this.handleEditOperation(row) }
                        }, '编辑');
                    },
                },


            ],
            tableData: [],
            dialogVisible: false,
            editRow: null,
            operationDes: '',
            // 日期范围选择器的本地数据（['yyyy-MM-dd', 'yyyy-MM-dd']），与 formDatas 解耦，避免把数组塞进查询对象
            dateRange: {
                createTime: [],
                exchangeTime: [],
            },
            // 日期范围快速选择项（纯数据：text + 起止日期计算函数，避免每个选择器重复定义逻辑）
            // 每项返回 [start, end]，调用方负责给 start 补 00:00:00、end 补 23:59:59
            shortcutList: [
                { text: '今天', getRange: () => { const e = new Date(); return [new Date(e), new Date(e)]; } },
                { text: '昨天', getRange: () => { const s = new Date(); s.setTime(s.getTime() - 1 * 864e5); return [new Date(s), new Date(s)]; } },
                { text: '近 7 天', getRange: () => { const e = new Date(); const s = new Date(); s.setTime(s.getTime() - 6 * 864e5); return [new Date(s), new Date(e)]; } },
                { text: '近 30 天', getRange: () => { const e = new Date(); const s = new Date(); s.setTime(s.getTime() - 29 * 864e5); return [new Date(s), new Date(e)]; } },
                { text: '本月', getRange: () => { const e = new Date(); return [new Date(e.getFullYear(), e.getMonth(), 1), new Date(e)]; } },
                { text: '近三月', getRange: () => { const e = new Date(); return [new Date(e.getFullYear(), e.getMonth() - 2, 1), new Date(e)]; } },
                { text: '近六月', getRange: () => { const e = new Date(); return [new Date(e.getFullYear(), e.getMonth() - 5, 1), new Date(e)]; } },
            ],
            // 两个选择器各自当前生效的快捷项文案（null 表示无匹配，按钮不高亮）
            activeShortcut: {
                createTime: null,
                exchangeTime: null,
            },
            formDatas: {
                arfdStatus: 1,
                currentPage: 1,
                pageSize: 10,
            },
        };
    },
    computed: {
        // 交易时间选择器的 picker-options（绑定 shortcuts，点击后填充范围并记录选中态）
        createTimePickerOptions() {
            return this.buildPickerOptions('createTime');
        },
        // 核销时间选择器的 picker-options
        exchangeTimePickerOptions() {
            return this.buildPickerOptions('exchangeTime');
        },
    },
    activated() {
        this.$nextTick(() => {
            this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                this.tableHight = calcTableHeight(this, val, 140);
            });
        },
    },
    deactivated() { },
    created() {
        this.tableHight = this.$store.state.windheight - 200 - this.$store.state.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        // 构造某选择器的 picker-options：把 shortcutList 转成 Element 期望的 shortcuts，点击时自动补时分秒
        buildPickerOptions(key) {
            const self = this;
            return {
                shortcuts: self.shortcutList.map(item => ({
                    text: item.text,
                    onClick(picker) {
                        const [start, end] = item.getRange();
                        picker.$emit('pick', [start, end]);
                        // 记录当前生效的快捷项文案，用于高亮按钮
                        self.activeShortcut[key] = item.text;
                        // emit pick 后面板关闭，DOM 更新后给按钮加高亮 class（下次打开可见）
                        self.$nextTick(() => self.syncShortcutActiveClass(key));
                    },
                })),
            };
        },
        // 给当前生效的快捷项按钮加高亮 class（同时清理旧高亮）
        syncShortcutActiveClass(key) {
            const target = this.activeShortcut[key];
            const popperList = document.querySelectorAll('.date-range-shortcut__panel');
            popperList.forEach(popper => {
                const buttons = popper.querySelectorAll('.el-picker-panel__shortcut');
                buttons.forEach(btn => {
                    const isActive = (btn.textContent || '').trim() === target;
                    btn.classList.toggle('is-active-shortcut', isActive);
                });
            });
        },
        // 计算日期范围与哪个快捷项匹配，不匹配返回 null
        // range 可显式传入（change 时用新值），不传则读 dateRange[key]（focus 恢复高亮时用）
        computeActiveShortcut(key, range) {
            const r = range || this.dateRange[key];
            if (!r || r.length !== 2 || !r[0] || !r[1]) return null;
            const matched = this.shortcutList.find(item => {
                const [s, e] = item.getRange();
                return this.formatDate(s) === r[0] && this.formatDate(e) === r[1];
            });
            return matched ? matched.text : null;
        },
        // 把 Date 格式化为 yyyy-MM-dd（与 value-format 一致），用于范围匹配
        formatDate(d) {
            const yyyy = d.getFullYear();
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const dd = String(d.getDate()).padStart(2, '0');
            return `${yyyy}-${mm}-${dd}`;
        },
        // 面板打开时：恢复当前生效快捷项的高亮（处理「上次点了快捷项、再次打开」的场景）
        onPickerFocus(key) {
            this.$nextTick(() => this.syncShortcutActiveClass(key));
        },
        // 交易时间范围变化：写回 formDatas 原字段（开始 00:00:00 / 结束 23:59:59）；手动改日期则清除高亮
        onCreateTimeRangeChange(val) {
            if (val && val.length === 2) {
                this.formDatas.createTimeStart = val[0] + ' 00:00:00';
                this.formDatas.createTimeEnd = val[1] + ' 23:59:59';
            } else {
                this.formDatas.createTimeStart = '';
                this.formDatas.createTimeEnd = '';
            }
            // 若是用户在日历上手动改日期（非点快捷项），需要重算并更新高亮
            this.activeShortcut.createTime = this.computeActiveShortcut('createTime', val);
            this.$nextTick(() => this.syncShortcutActiveClass('createTime'));
            this.partserch();
        },
        // 核销时间范围变化：同上，同步到 exchangeTimeStart / exchangeTimeEnd
        onExchangeTimeRangeChange(val) {
            if (val && val.length === 2) {
                this.formDatas.exchangeTimeStart = val[0] + ' 00:00:00';
                this.formDatas.exchangeTimeEnd = val[1] + ' 23:59:59';
            } else {
                this.formDatas.exchangeTimeStart = '';
                this.formDatas.exchangeTimeEnd = '';
            }
            this.activeShortcut.exchangeTime = this.computeActiveShortcut('exchangeTime', val);
            this.$nextTick(() => this.syncShortcutActiveClass('exchangeTime'));
            this.partserch();
        },
        openLoading() {
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        handleExport() {
            var s = qs.stringify(this.formDatas);
            this.openLoading();
            var that = this;
            axios({
                method: 'post',
                url: config.baseURL + '/ajef-rights-fund-deduct-copy/exportAjefRightsFundDeductCopy',
                data: s,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'useref': window.localStorage.getItem('Qy_token')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close();
                    let a = document.createElement('a');
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '订单记录.xlsx');
                    a.click();
                    that.$message({
                        message: "导出成功",
                        type: "success"
                    });
                }
            }).catch(() => {
                that.loadings.close();
            });
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            this.formDatas.currentPage = pageIndex;
            this.tableLoading = true;
            getAjefRightsFundDeductCopyList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        partserch() {
            this.formDatas.currentPage = 1;
            this.tableLoading = true;
            getAjefRightsFundDeductCopyList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        getList() {
            this.tableLoading = true;
            getAjefRightsFundDeductCopyList(this.formDatas).then((res) => {
                this.tableLoading = false;
                this.tableData = res.data;
                this.totalCount = res.total;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        handleEditOperation(row) {
            this.editRow = row;
            this.operationDes = row.arfdHandlerOperation || '';
            this.dialogVisible = true;
        },
        saveOperationDes() {
            if (!this.editRow) return;
            updateAjefRightsFundDeductCopyHandlerOperation({
                arfdId: this.editRow.arfdId,
                arfdHandlerOperation: this.operationDes
            }).then(() => {
                this.$message.success('保存成功');
                this.dialogVisible = false;
                this.getList();
            }).catch(() => {
                this.$message.error('保存失败');
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}

.filter-row {
    margin: 0 10px;
    width: 98%;
    display: flex;
    padding-left: 20px;
    flex-wrap: wrap;
}

.filter-row>* {
    margin-top: 5px;
    margin-left: 10px;
}

.filter-row>*:first-child {
    margin-left: 0;
}

.el-date-editor .el-range-separator {
    padding: 0 0px;
}

/* ===== 日期范围选择器：快捷项侧栏样式美化（弹层挂载在 body 下，必须用全局样式） ===== */
.date-range-shortcut__panel .el-picker-panel__sidebar {
    /* 侧栏整体：加宽 + 浅色背景，与右侧日历区拉开层次 */
    width: 110px;
    background: #f7f9fc;
    border-right: 1px solid #ebeef5;
    padding: 8px 0;
}

.date-range-shortcut__panel .el-picker-panel__shortcut {
    /* 单个快捷按钮：增大点击区、改善排版、加过渡动画 */
    min-height: 34px;
    line-height: 34px;
    padding: 0 18px 0 16px;
    font-size: 13px;
    color: #5a6b7e;
    position: relative;
    transition: all 0.2s ease;
    border-left: 3px solid transparent;
    /* 预留选中色条位置，避免点击时文字跳动 */
}

.date-range-shortcut__panel .el-picker-panel__shortcut:hover {
    /* hover：浅蓝底 + 主色文字 + 左侧色条 */
    background: #ecf5ff;
    color: #409eff;
    border-left-color: #409eff;
    padding-left: 16px;
}

/* 选中态：实心高亮，明确标识当前生效的快捷项 */
.date-range-shortcut__panel .el-picker-panel__shortcut.is-active-shortcut {
    background: #409eff;
    color: #ffffff;
    font-weight: 500;
    border-left-color: #1f6fd0;
}

.date-range-shortcut__panel .el-picker-panel__shortcut.is-active-shortcut:hover {
    /* 选中项 hover 时保持高亮，不改色 */
    background: #409eff;
    color: #ffffff;
    border-left-color: #1f6fd0;
}
</style>
